// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"649e9eb0","260":"7c4a3d71","275":"b5a3e443","318":"2135a6df","407":"4320420d","420":"e223a8e1","427":"f021dc9e","709":"6c403432","977":"74c09a9d","998":"2c6c0373"}[chunkId] + ".chunk.js";
};